import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {
  Wrapper,
  Box,
  ShareShow,
  ShareHidden,
  Link,
} from './style';

import AppState from '../../states/AppState';

class ShareButtons extends Component {
  constructor() {
      super()
      this.state = {
        myText: 'Click to copy'
      }
  }

  position(scrollTop, windowHeight) {
    if (scrollTop < 0) {
      return 'fixed-bottom';
    } else if (scrollTop > windowHeight - (3 * AppState.rem)) {
      return 'fixed-top';
    } else {
      return 'absolute';
    }
  }

  updateText = () => {
    var textField = document.createElement('textarea');
    textField.innerText = window.location.href;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    this.setState({myText: 'Copied!'});
    setTimeout(function() {
      this.setState({myText: 'Click to copy'});
    }.bind(this), 1000);
  }

  render() {
    return (
      <Wrapper
        className={AppState.scrollTop > 5 ? 'active' : 'inactive'}
        position={this.position(AppState.scrollTop, AppState.windowHeight)}
      >
        <Box>
          <ShareShow>Share</ShareShow>
          <ShareHidden onClick={this.updateText}>{this.state.myText}</ShareHidden>
        </Box>
      </Wrapper>
    );
  }
}

export default observer(ShareButtons);



// WEBPACK FOOTER //
// ./src/components/ShareButtons/index.js